import React from 'react';

const styles = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
    gap: 10,
  },
};

export default function MetricGrid({ children, minWidth = 160 }) {
  return (
    <div style={{ ...styles.grid, gridTemplateColumns: `repeat(auto-fill, minmax(${minWidth}px, 1fr))` }}>
      {children}
    </div>
  );
}
